import React from "react";

import LSBdDisplay03 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay03";
import LSRgH2HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import { useRecoilState } from "recoil";
import { onboardingState } from "../../../store/onboardingState";

import RadioForm from "../../molecules/onboarding/radioForm";
import useDisplay from "../../../hooks/useDisplay";

const Step01 = ({ style }) => {
  const { isMobile, isTablet, isDesktop } = useDisplay();

  const [onboardingStateAtom, setOnboardingStateAtom] =
    useRecoilState(onboardingState);

  const questionList01 = [
    {
      title: "자영업자",
      value: "사업자",
    },
    {
      title: "직장인",
      value: "직장인",
    },
    {
      title: "프리랜서",
      value: "사업자",
    },
    {
      title: "무직",
      value: "사업자",
    },
  ];
  const questionList02 = [
    {
      title: "1천만원~3천만원",
      value: "지식,재테크 기초,부동산 기초,경제 기초",
    },
    {
      title: "3천만원~5천만원",
      value: "지식,실전,부동산 기초",
    },
    {
      title: "5천만원~1억",
      value: "지식,실전,대출 중급",
    },
    {
      title: "1억 초과",
      value: "실전,대출 중급",
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        ...style,
      }}
    >
      <img
        style={{
          height: "auto",
          width: "100%",
          marginBottom: isMobile ? 30 : 50,
        }}
        src="/assets/images/onboarding01.png"
        alt="onboarding01"
      />

      <LSBdDisplay03
        style={{
          color: "#000000",
          marginBottom: 16,
          fontSize: isMobile ? 20 : 32,
          lineHeight: isMobile ? "28px" : "44.8px",
        }}
      >
        11가지 금융 고민 온보딩을 통해
        <br />
        나에게 가장 적합한 맞춤 강의를 추천받으세요!
      </LSBdDisplay03>
      <LSRgH2HeadLine
        style={{
          color: "#000000",
          marginBottom: isMobile ? 30 : 66,
          fontSize: isMobile ? 14 : 18,
          lineHeight: isMobile ? "19.6px" : "25.2px",
        }}
      >
        11가지 금융과 관련된 질문에 답을 하고, 나에게 가장 적합한 맞춤 강의를
        추천받으세요! <br />
        대출부터 부동산, 재테크 등등 다양한 강의를 추천받아 수강할 수 있어요.
      </LSRgH2HeadLine>

      <RadioForm
        questionList={questionList01}
        questionValue={onboardingStateAtom.question01}
        questionKey={"question01"}
        numbering={"01."}
        title={"직업이 어떻게 되시나요?"}
      />

      <RadioForm
        style={{
          marginTop: 60,
        }}
        questionList={questionList02}
        questionValue={onboardingStateAtom.question02}
        questionKey={"question02"}
        numbering={"02."}
        title={"현재 고정 연수입은 대략 어느 정도 인가요?"}
      />
    </div>
  );
};

export default Step01;
